import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["icon", "text", "button"];

  connect() {
    this.form = this.element.closest("form");
    if (this.form) {
      this.form.addEventListener("submit", (e) => this.showLoading(e));
      this.form.addEventListener("turbo:submit-end", (e) => this.handleSubmitEnd(e));
    }
  }

  handleSubmitEnd(event) {
    const success = event.detail?.success;
    const fetchResponse = event.detail?.fetchResponse;
    const status = fetchResponse?.statusCode;

    // Reset spinner if request failed or was blocked by Cloudflare/WAF (>= 400)
    if (!success || (status && status >= 400)) {
      this.reset();
    }
  }

  ensureIcon() {
    if (this.hasIconTarget) return;

    // cria o ícone se não existir
    const icon = document.createElement("i");
    icon.className = "fa-solid fa-circle me-2"; // ícone padrão
    icon.dataset.loadingButtonTarget = "icon";

    this.buttonTarget.insertBefore(icon, this.buttonTarget.firstChild);
  }

  showLoading(event) {
    if (this.isLoading) return;

    this.ensureIcon(); // garante que exista ícone

    this.isLoading = true;
    this.buttonTarget.disabled = true;

    // esconde o ícone
    if (this.hasIconTarget) {
      this.iconTarget.style.display = "none";
    }

    // cria spinner
    this.spinner = document.createElement("div");
    this.spinner.classList.add("loading-spinner");
    this.buttonTarget.appendChild(this.spinner);
  }

  reset() {
    this.isLoading = false;
    this.buttonTarget.disabled = false;

    if (this.spinner) this.spinner.remove();

    // reexibe o ícone (agora garantidamente existente)
    if (this.hasIconTarget) {
      this.iconTarget.style.display = "inline-block";
    }
  }
}
